/** Repository translations win; Console can still contribute exclusive keys. */
export const mergeTranslations = (hostedTranslations = {}, localeMessages = {}) => ({
  ...hostedTranslations,
  ...localeMessages,
});
